<template lang="html">
  <v-app>
    <section class="about">
      <SubTitle
        :TitleName="'http://d-mebius.com/miasmabreaker/assets/index_system.png'"
        :AltText="'システム'"
      />
      <div class="story_page page-bottom" key="story_page">
        <SubTitle
          :TitleName="'http://d-mebius.com/miasmabreaker/assets/caption_03.png'"
          :AltText="'除霊任務を受けて夜の街へ'"
        />
        <div class="text-column">
          <p>
            事務所にあるデスクから受ける任務を選択することができます。<br />
            STORYアイコンが付いている任務を達成することで物語が進行し、受けられる任務が増えていきます。<br />
            物語が進行するほど任務の難易度が上がっていきますが、得られる報酬も増加していきます。
          </p>
        </div>
        <v-container>
          <v-row class="justify-center ma-8">
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-img
                width="480"
                src="http://d-mebius.com/miasmabreaker/assets/ss05.png"
                @click="
                  openDialog(
                    'http://d-mebius.com/miasmabreaker/assets/ss05.png'
                  )
                "
              ></v-img>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-img
                width="480"
                src="http://d-mebius.com/miasmabreaker/assets/ss06.png"
                @click="
                  openDialog(
                    'http://d-mebius.com/miasmabreaker/assets/ss06.png'
                  )
                "
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row
            v-for="(systems, index) in systems"
            :key="index"
            justify-center
            class="ma-5"
          >
            <v-col
              style="text-align: center;"
              cols="12"
              md="6"
              class="d-flex justify-center"
              ><v-img
                :src="systems.src"
                width="480px"
                @click="openDialog(systems.src)"
              ></v-img
            ></v-col>
            <v-col cols="12" md="6">
              <v-img
                :src="systems.src2"
                :alt="systems.alt"
                max-width="432px"
              ></v-img>
              <p v-html="formatDescription(systems.description)"></p
            ></v-col>
          </v-row>
        </v-container>
      </div>
      <div class="story_page page-bottom">
        <SubTitle
          :TitleName="'http://d-mebius.com/miasmabreaker/assets/caption_04.png'"
          :AltText="'スキルの組み合わせでキャラクタービルド'"
        />
        <div class="text-column">
          <p>
            事務所のデスクでキャラクターの能力を強化することができます。<br />
            任務達成で得られる報酬を消費しますので、様々な任務を達成して能力を強化していきましょう。
          </p>
        </div>
        <v-container>
          <v-row
            v-for="(systems2, index) in systems2"
            :key="index"
            justify-center
            class="ma-5"
          >
            <v-col
              style="text-align: center;"
              cols="12"
              md="6"
              class="d-flex justify-center"
              ><v-img
                :src="systems2.src"
                width="480px"
                @click="openDialog(systems2.src)"
              ></v-img
            ></v-col>
            <v-col cols="12" md="6">
              <v-img
                :src="systems2.src2"
                :alt="systems2.alt"
                max-width="432px"
              ></v-img>
              <p v-html="formatDescription(systems2.description)"></p
            ></v-col>
          </v-row>
        </v-container>
      </div>
    </section>
    <v-dialog v-model="dialog" max-width="1280">
      <v-img :src="selectedImage"></v-img>
    </v-dialog>
  </v-app>
</template>

<style></style>
<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    data() {
      return {
        dialog: false,
        selectedImage: "",
        systems: [
          {
            src: "http://d-mebius.com/miasmabreaker/assets/ss07.png",
            src2: "http://d-mebius.com/miasmabreaker/assets/sub_01.png",
            alt: "エリア除霊",
            description:
              "戦闘エリア内のミアズマを撃破することで右下のゲージが減少していきます。<br>一定量撃破することで任務達成となります。<br>迫りくる大量のミアズマを撃破しよう！",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/ss08.png",
            src2: "http://d-mebius.com/miasmabreaker/assets/sub_02.png",
            alt: "ミアズマ除霊",
            description:
              "ターゲットとして指定されたミアズマを一定量撃破することで任務達成となります。<br>ターゲット外のミアズマを撃破しても任務を達成することができないので注意しましょう。<br>周囲のミアズマ撃破を優先するか、ターゲットに狙いを絞るかの判断が重要です！",
          },
        ],
        systems2: [
          {
            src: "http://d-mebius.com/miasmabreaker/assets/ss09.png",
            src2: "http://d-mebius.com/miasmabreaker/assets/sub_03.png",
            alt: "能力強化",
            description:
              "任務で得られた資金を支払って能力を強化します。<br>除霊範囲や除霊速度を上げる基本能力や、守護霊攻撃の種類を増やす「守護霊ランク」を上げる物まで様々です。",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/ss10.png",
            src2: "http://d-mebius.com/miasmabreaker/assets/sub_04.png",
            alt: "特別報酬",
            description:
              "任務中に条件を達成すると報酬を得られます。<br>資金や「除霊スキル」など様々な報酬を手に入れることができます。<br>特定のミアズマの撃破など、任務を繰り返すことで達成できるものが多いので、高難度の任務達成が困難な場合は特別報酬でキャラクターを強化しましょう。",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/ss11.png",
            src2: "http://d-mebius.com/miasmabreaker/assets/sub_05.png",
            alt: "守護霊ランク",
            description:
              "能力強化で守護霊のランクを上げることができます。<br>ランクを上げるとレベルアップした際に選択できる守護霊攻撃の種類が増加します。<br>プレイスタイルに合わせて様々は守護霊攻撃を使いこなしましょう！",
          },
          {
            src: "http://d-mebius.com/miasmabreaker/assets/ss12.png",
            src2: "http://d-mebius.com/miasmabreaker/assets/sub_06.png",
            alt: "除霊スキル",
            description:
              "一度に除霊する魂の数に応じて除霊スキルが発動します。<br>強力な性能を持っていますが一定時間で効果が消えてしまうので、効果を絶やさないように除霊するタイミングを見極めることが重要です。<br>自由に付け替えて好みのプレイスタイルを見つけてみましょう。",
          },
        ],
      };
    },
    methods: {
      formatDescription(description) {
        return description.replace(/\n/g, "<br>");
      },
      openDialog(imageName) {
        this.selectedImage = imageName;
        this.dialog = true;
        console.log(this.selectedImage); // ここで値を確認
      },
    },
  };
</script>
